import React, { useState, useEffect } from "react";
import moment from "moment";
import { Row, Col, Card, Table, Input, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import LoadingOverlay from "../loadingOverlay/loadingOverlay";

const TableRelationshipsFinished = ({
    individualResults,
    selectedEvaluation,
    refreshTable,
    pagination,
    onPageChange,
}) => {
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        moment.locale('es-us');
    }, []);

    const getFilters = (data, key) => {
        const uniqueValues = [...new Set(data.map(item => item[key]))];
        return uniqueValues.map(value => ({ text: value, value }));
    };

    const filteredData = individualResults.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const columns = [
        {
            title: "Nombre(s)",
            dataIndex: "first_name",
            key: "first_name",
            fixed: "left",
            sorter: (a, b) => a.first_name.localeCompare(b.first_name),
        },
        {
            title: "Apellido(s)",
            dataIndex: "last_name",
            key: "last_name",
            fixed: "left",
            sorter: (a, b) => a.last_name.localeCompare(b.last_name),
        },
        {
            title: "Identificación",
            dataIndex: "dni",
            key: "dni",
            fixed: "left",
            sorter: (a, b) => a.dni - b.dni,
        },
        {
            title: "Gerencia",
            dataIndex: "management_area",
            key: "management_area",
            sorter: (a, b) => a.management_area.localeCompare(b.management_area),
            filters: getFilters(individualResults, "management_area"),
            onFilter: (value, record) => record.management_area === value,
        },
        {
            title: "Área",
            dataIndex: "area",
            key: "area",
            sorter: (a, b) => a.area.localeCompare(b.area),
            filters: getFilters(individualResults, "area"),
            onFilter: (value, record) => record.area === value,
        },
        {
            title: "Cargo",
            dataIndex: "job_title",
            key: "job_title",
            sorter: (a, b) => a.job_title.localeCompare(b.job_title),
            filters: getFilters(individualResults, "job_title"),
            onFilter: (value, record) => record.job_title === value,
        },
        {
            title: "Sede",
            dataIndex: "headquarter",
            key: "headquarter",
            sorter: (a, b) => a.headquarter.localeCompare(b.headquarter),
            filters: getFilters(individualResults, "headquarter"),
            onFilter: (value, record) => record.headquarter === value,
        },
        {
            title: "Acciones",
            key: "actions",
            fixed: "right",
            render: (_, record) => (
                <Button
                    size="small"
                    type="primary"
                    onClick={() => seeIndividualInform(selectedEvaluation.evl_id, record.dni)}
                >
                    Ver informe
                </Button>
            )
        }
    ];

    const seeIndividualInform = (evl_id, dni) => {
        const rootUrl = window.location.origin;
        const url = `${rootUrl}/informes/individual/${evl_id}/${dni}`;
        window.open(url, '_blank');
    };

    return (
        <Row gutter={[16, 16]} align="stretch">
            {/* Informes individuales */}
            <Col xs={24} md={24}>
                <Card title="Informes individuales" bordered style={{ height: '100%' }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
                        <Input
                            placeholder="Buscar colaborador"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            allowClear
                            style={{ flex: 1, marginRight: 15 }}
                        />
                    </div>

                    <Table
                        size="small"
                        columns={columns}
                        dataSource={filteredData}
                        rowKey="dni"
                        pagination={{
                            current: pagination?.page || 1,
                            pageSize: pagination?.pageSize || 20,
                            total: pagination?.total || filteredData.length,
                            position: ["bottomRight"],
                            showSizeChanger: false,
                        }}
                        onChange={(pager) => onPageChange?.(pager.current, pager.pageSize)}
                        scroll={{ x: "max-content" }}
                    />
                </Card>
            </Col>
        </Row>
            
    );
};

export default TableRelationshipsFinished;
